import { useRouter } from 'next/navigation';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getTrackerUrl } from '@/redux/store/actions/generalActions';
import { toast } from 'react-toastify';
import { useIsWhiteLabel } from '@/components/app/providers/whiteLabelProvider/WhiteLabelProvider';
import styles from './Categories.module.scss';
import Image from 'next/image';
import Link from 'next/link';
import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
import Cottage from '@/public/images/home/categories/home-hashtag.svg';
import Boomgardi from '@/public/images/home/categories/boomgardi.svg';
import Pool from '@/public/images/home/categories/Pool.svg';
import Coastal from '@/public/images/home/categories/sun-fog.svg';
import Forest from '@/public/images/home/categories/Bagh.svg';
import Airplane from '@/public/images/home/categories/Airplane.svg';
import Discount from '@/public/images/home/categories/percentage-square.png';
import Hotel from '@/public/images/home/categories/Hotel.svg';
import Badges from '@/components/UI/badges/Badges';
const CategoriesItem = [
// {
//   title: 'اجاره ماهانه تهران',
//   image: MidTerm,
//   discount: '۳۰٪ ارزان‌تر',
//   link: '/search/city/تهران?mid_term=1',
// },
{
  title: 'مدت دار',
  image: Discount,
  link: '/search?discount_days=1'
}, {
  title: 'استخردار',
  image: Pool,
  link: '/search?pool=1'
}, {
  title: 'کلبه',
  image: Cottage,
  link: '/all-cottage'
}, {
  title: 'بومگردی',
  image: Boomgardi,
  link: '/all-boomgardi'
}, {
  title: 'ساحلی',
  image: Coastal,
  link: '/search?coastal=1'
}, {
  title: 'جنگلی',
  image: Forest,
  link: '/search?forest=1'
}];
const Categories = () => {
  // LONG TERM COMPONENTS (!! DO NOT DELETE IT WILL RELEASE AGAIN !!)
  // const isWhiteLabel = useIsWhiteLabel()
  // const categoryList = isWhiteLabel ? CategoriesItem.slice(1) : CategoriesItem
  const isWhiteLabel = useIsWhiteLabel();
  const dispatch = useDispatch();
  const router = useRouter();
  const {
    bootstrapData,
    trackerUrl
  } = useSelector(state => ({
    bootstrapData: state.bootstrapData,
    trackerUrl: state.trackerUrl
  }));
  const has_active_company = bootstrapData?.data?.user_info?.has_active_company;
  useEffect(() => {
    if (trackerUrl?.data?.redirect_url) {
      router.push(trackerUrl.data.redirect_url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trackerUrl.data]);

  // const handleGetUrl = e => {
  //   e.preventDefault()
  //   if (trackerUrl.loading) return
  //   dispatch(
  //     getTrackerUrl('raman', ({ status, message }) => {
  //       if (status) {
  //         toast.error(message)
  //       }
  //     }),
  //   )
  // }

  const companyCategories = [{
    title: 'هتل',
    image: Hotel,
    link: '/hotels'
  }, {
    title: 'پرواز',
    image: Airplane,
    link: '/flight'
  }];
  return <Box className={styles['categories-container']} data-sentry-element="Box" data-sentry-component="Categories" data-sentry-source-file="Categories.tsx">
      {/*<SnappPay />*/}
      {!isWhiteLabel && has_active_company && companyCategories.map((item, index) => <Link href={item.link} key={'COMPANY_CATEGORIES_ITEM_' + index} className={styles['category-link']}>
            <Box className={styles['category-item-container']} component={'figure'}>
              <Box component={'span'} className={styles['category-image-box']}>
                <Image src={item.image} alt={item.title} width={32} height={32} />
              </Box>
              <Typography variant="bodyM" className={styles['category-title']} component="figcaption">
                {item.title}
              </Typography>
              <Badges label="جدید" type="error-filled" className={styles['new-product-badge']} />
            </Box>
          </Link>)}
      {CategoriesItem.map((item, index) => <Link href={item.link} key={'CATEGORIES_ITEM_' + index} className={styles['category-link']}>
          <Box className={styles['category-item-container']} component={'figure'}>
            <Box component={'span'} className={styles['category-image-box']}>
              <Image src={item.image} alt={item.title} width={32} height={32} />
            </Box>
            <Typography variant="bodyM" className={styles['category-title']} component="figcaption">
              {item.title}
            </Typography>

            {/*LONG TERM DISCOUNT BADGE*/}
            {/*{item?.discount && (*/}
            {/*  <Typography*/}
            {/*    variant="descriptionM"*/}
            {/*    className={styles['discount-badge']}*/}
            {/*  >*/}
            {/*    {item?.discount}*/}
            {/*  </Typography>*/}
            {/*)}*/}
          </Box>
        </Link>)}
    </Box>;
};
export default Categories;